import { forwardRef as R, useState as S, useCallback as j } from "react";
import { useThemeUI as z, Box as v } from "theme-ui";
import * as r from "@radix-ui/react-toast";
import { Cross24Icon as N } from "@material-bank/mb-icons";
import { errorToast as P, rightActions as U, actionIconButton as u, collapsible as $, collapsibleContent as q } from "./styles.js";
import { Stack as e } from "../Stack/Stack.js";
import "@material-bank/ds-utils";
import { Text as D } from "../Typography/Text.js";
import { jsx as o, jsxs as i } from "theme-ui/jsx-runtime";
import { CenteredBox as E } from "../CenteredBox/CenteredBox.js";
import "../Button/Button.js";
import { IconButton as b } from "../Button/IconButton/IconButton.js";
import "@theme-ui/css";
import "../../lib/css/match-media-context.js";
import { CollapseArrow as F } from "../CollapseArrow/CollapseArrow.js";
import { Collapsible as G } from "../Collapsible/Collapsible.js";
import "@radix-ui/react-collapsible";
const H = R((g, T) => {
  const {
    variant: A = "primary",
    title: I,
    startIcon: s,
    button: a,
    actionAltText: B,
    collapsibleContent: p,
    showCloseButton: w = !0,
    onToggleCollapsible: t,
    rightActionsSx: y,
    ...c
  } = g, n = !!a, l = !!p, m = w && !n, d = m || n || l, {
    theme: x
  } = z(), [h, C] = S(!1), O = j(() => {
    C((k) => {
      const f = !k;
      return t == null || t(f), f;
    });
  }, [t]);
  return /* @__PURE__ */ o(r.Root, {
    ...c,
    ref: T,
    sx: {
      ...x.toast,
      ...A === "error" && P,
      ...c.sx
    },
    children: /* @__PURE__ */ i(e, {
      children: [/* @__PURE__ */ i(e, {
        gap: 2,
        direction: "row",
        sx: {
          alignItems: "flex-start"
        },
        children: [/* @__PURE__ */ i(e, {
          direction: "row",
          gap: 2,
          sx: {
            py: 1,
            ...!s && {
              pl: 1
            },
            ...!d && {
              pr: 1
            },
            alignItems: "flex-start"
          },
          children: [s && /* @__PURE__ */ o(E, {
            sx: {
              flexShrink: 0
            },
            children: s
          }), /* @__PURE__ */ o(r.Title, {
            asChild: !0,
            children: /* @__PURE__ */ o(D, {
              children: I
            })
          })]
        }), d && /* @__PURE__ */ i(e, {
          direction: "row",
          gap: x.spacing(0.5),
          sx: {
            ...U,
            ...y
          },
          children: [n && /* @__PURE__ */ o(r.Action, {
            asChild: !0,
            altText: B ?? "Toast Action",
            sx: {
              mr: 1
            },
            children: a
          }), l && /* @__PURE__ */ o(b, {
            icon: /* @__PURE__ */ o(F, {
              open: h
            }),
            size: "sm",
            onClick: O,
            sx: u
          }), m && /* @__PURE__ */ o(r.Close, {
            asChild: !0,
            "aria-label": "Close",
            children: /* @__PURE__ */ o(b, {
              icon: /* @__PURE__ */ o(N, {}),
              size: "sm",
              sx: u
            })
          })]
        })]
      }), l && /* @__PURE__ */ o(G, {
        open: h,
        onOpenChange: C,
        sx: $,
        children: /* @__PURE__ */ o(v, {
          sx: q,
          children: p
        })
      })]
    })
  });
});
H.displayName = "Toast";
export {
  H as Toast
};
